import React, { ChangeEvent, useCallback, useMemo } from "react";
import { TextInput } from "@alm/flow-ds/components";
import { ElementComponentProps } from "elements/types";
import { TextInputElement } from "records/Element";
import { useSelector } from "react-redux";
import { State } from "data";
import {
	createGetElementData,
	ElementComponentData,
} from "data/form/elementSelectors";
import { useStandardElement } from "components/Forms/Element";
import { useDebounceSetDataReactive } from "hooks/useDebounceSetData";
import { DisplayOnlyValue } from "elements";

function TextInputSingleReactive({
	fid,
	vid,
	id,
	index,
	rowIndex,
	uuid,
	hint,
	label,
	required,
	disabled,
	validation,
	displayOnly,
	elem,
}: ElementComponentProps<TextInputElement>) {
	const getData = useMemo(createGetElementData, []);

	const selectorProps = useMemo(
		() => ({ fid, vid, id, index, rowIndex, uuid }),
		[fid, vid, id, index, rowIndex, uuid]
	);

	const data = useSelector((state: State) =>
		getData(state, selectorProps)
	) as ElementComponentData<string | number>;

	const { eid, setDataAndQueue } = useStandardElement({
		fid,
		vid,
		id,
		index,
		rowIndex,
		uuid,
	});

	const { value, onBlur, onChange } = useDebounceSetDataReactive(
		setDataAndQueue,
		data
	);

	const handleOnChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			const value = event.currentTarget.value;

			const formatValue = elem === "number" ? parseFloat(value) : value;

			onChange(formatValue);
		},
		[elem, onChange]
	);

	// Display only
	if (displayOnly) {
		return <DisplayOnlyValue label={label} value={value} />;
	}

	return (
		<TextInput
			id={eid}
			value={value.toString()}
			type={elem}
			maxLength={validation?.maxLength}
			onChange={handleOnChange}
			onBlur={onBlur}
			disabled={disabled}
			status={data.status}
			label={label}
			feedback={data.feedback}
			hint={hint}
			required={required}
		/>
	);
}

export default React.memo(TextInputSingleReactive);
